import React, { useContext } from 'react';
import { ArticleInfo } from '../Common/ArticleInfo';
import styled from 'styled-components'
import { UserOptions } from './UserOptions';
import { RecommendationPanel } from './RecommendationPanel';
import { CheckoutHeader } from '../Common/CheckoutHeader';
import { ArticleContext, ShopSettingsContext } from '../../FootprintTech/AppController';
import {
  Matching,
} from '../../interfaces/ProductService.interface';
import EventEmitter from 'eventemitter3';
import log from '../../services/LogService';
import { SizePanel } from './SizePanel';

const ParentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const HalluxPanel = styled.div`
  font-size: 18px;
  line-height: 1.4;
  margin-top: -20px;
`;

interface RecommendationProps {
  emitter: EventEmitter;
  matching: Matching;
  recommendationPriceEnabled: boolean;
  recommendationMatchingCodeEnabled: boolean;
  hasPiFrames: boolean;
}

export function RecommendationComponent(props: RecommendationProps) {

  const {
    matching,
    emitter,
    recommendationPriceEnabled,
    recommendationMatchingCodeEnabled,
    hasPiFrames,
  } = props;

  const shopSettings = useContext(ShopSettingsContext);
  const article = useContext(ArticleContext);

  const hasHallux = !!(matching.hallux_right || matching.hallux_left);
  let ra:number, la:number;

  if (hasHallux) {
    ra = matching.hallux_right || 0;
    la = matching.hallux_left || 0;
  }

  const hasArchType = !!matching.arch_type;

  log.info(`article sizes ${article.sizes}`);
  log.info(`article sum ${article.sum}`);
  const availability = shopSettings.addToCartEnabled? 0 : 1;
  log.info(`Availability: ${availability}`);

  return (
    <ParentContainer>
      <RecommendationPanel>
        <CheckoutHeader
          matching={matching}
          emitter={emitter} ></CheckoutHeader>
        <ArticleInfo
          articleName={article.name}
          manufacturer={article.manufacturer}
          productSrc={article.image} matching={matching}
          sum={article.sum}
          emitter={emitter}
          recommendationPriceEnabled={recommendationPriceEnabled}
          recommendationMatchingCodeEnabled={recommendationMatchingCodeEnabled}>
        </ArticleInfo>
        <SizePanel matching={matching}></SizePanel>
        { hasHallux &&
          <HalluxPanel>Hallux Winkel: L {la.toPrecision(2)}° / R {ra.toPrecision(2)}°</HalluxPanel>
        }
        <UserOptions
          availability={availability}
          matching={matching}
          emitter={emitter}
          hasPiFrames={hasPiFrames}></UserOptions>
      </RecommendationPanel>
      </ParentContainer>
  );
}
